module.exports = __webpack_public_path__ + "static/media/search.96f386c4.svg";